import cn from 'classnames'
import styles from './styles.module.css'
import TagsCheckbox from '../tags-checkbox'

const TagsCheckboxGroup = ({
    onUpdated,
    label,
    values = [],
    handleChange,
    className,
    labelClassName,
    tagsClassName,
    checkboxClassName,
    newsList
}) => {
    return <div className={cn(styles.checkboxGroup, className)}>
        {label && <div className={cn(styles.label, labelClassName)}>
            {label}
        </div>}

        <div className={cn(styles.checkboxGroupItems, tagsClassName)}>
            {values.map(item => {
                return <TagsCheckbox
                    key={item.id}
                    id={item.id}
                    value={item.value}
                    name={item.name}
                    color={item.color}
                    onChange={handleChange}
                    className={checkboxClassName}
                    count={newsList.results?.filter((news) => news.tags?.some((tag) => tag.slug === item.slug)).length}
                />
            })}
        </div>
    </div>
}

export default TagsCheckboxGroup